import type { FichaPresenca } from '../types';
import { AvatarPessoa, PilhaEstado } from './VisualPessoa';

interface Props {
  ficha: FichaPresenca;
  naJanela: boolean;
  enviando: boolean;
  erro: string | null;
  aoTirarFoto: () => void;
}

export default function CartaoOutraPessoa({
  ficha,
  naJanela,
  enviando,
  erro,
  aoTirarFoto,
}: Props) {
  const { presenca } = ficha;
  const semTentativas = ficha.pode_reenviar === false;

  return (
    <div className="rounded-2xl border border-secondary-200 bg-white p-4 shadow-sm">
      <div className="flex items-center gap-3">
        <AvatarPessoa nome={ficha.nome} confirmada={presenca === 'confirmada'} />
        <div className="min-w-0 flex-1">
          <p className="text-[15px] font-bold text-foreground-950">{ficha.nome}</p>
          <p className="text-xs text-secondary-500">ficha na sua conta</p>
        </div>
        <PilhaEstado presenca={presenca} />
      </div>

      {presenca === 'nenhuma' && (
        <div className="mt-4">
          <div className="rounded-lg border border-dashed border-accent-300 bg-accent-100 px-3 py-2.5">
            <p className="text-sm text-foreground-800">
              Tire uma foto de vocês dois juntos, aqui na formação.
            </p>
          </div>
          {erro && <p className="mt-2 text-sm text-red-600">{erro}</p>}
          <button
            type="button"
            onClick={aoTirarFoto}
            disabled={!naJanela || enviando}
            className="mt-3 flex h-11 min-h-[44px] w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 text-sm font-bold text-white transition-colors hover:bg-accent-600 disabled:cursor-not-allowed disabled:bg-secondary-300"
          >
            {enviando ? 'Enviando…' : '📸 Tirar a foto'}
          </button>
        </div>
      )}

      {presenca === 'recusada' && (
        <div className="mt-4">
          <p className="text-sm text-red-700">A direção não conseguiu confirmar.</p>
          {ficha.motivo_recusa && (
            <p className="mt-1 text-xs text-secondary-500">{ficha.motivo_recusa}</p>
          )}
          {erro && <p className="mt-2 text-sm text-red-600">{erro}</p>}
          {semTentativas ? (
            <p className="mt-3 text-sm font-medium text-secondary-700">
              Já foram 3 tentativas. Procure alguém da direção — eles marcam na hora.
            </p>
          ) : (
            <button
              type="button"
              onClick={aoTirarFoto}
              disabled={!naJanela || enviando}
              className="mt-3 flex h-11 min-h-[44px] w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 text-sm font-bold text-white transition-colors hover:bg-accent-600 disabled:cursor-not-allowed disabled:bg-secondary-300"
            >
              {enviando ? 'Enviando…' : '📸 Tirar outra foto'}
            </button>
          )}
        </div>
      )}
    </div>
  );
}